import { useState } from 'react';
import ExamDashboard from '@/components/exam/ExamDashboard';
import ExamInterface from '@/components/exam/ExamInterface';
import ResultsPage from '@/components/exam/ResultsPage';
import { Exam, StudentAnswer, ExamResult } from '@/types/exam';

type ExamViewType = 'dashboard' | 'exam' | 'results';

export default function Exams() {
  const [viewType, setViewType] = useState<ExamViewType>('dashboard');
  const [selectedExam, setSelectedExam] = useState<Exam | null>(null);
  const [examResult, setExamResult] = useState<ExamResult | null>(null);

  // Mock class rankings - replace with real data
  const mockClassRankings: ExamResult[] = [
    {
      id: '1',
      examId: selectedExam?.id || '',
      studentId: 'STU002',
      studentName: 'Chioma Okonkwo',
      totalMarks: 100,
      marksObtained: 92,
      percentage: 92,
      grade: 'A',
      answers: [],
      startTime: new Date(),
      endTime: new Date(),
      duration: 60,
      position: 1,
    },
    {
      id: '2',
      examId: selectedExam?.id || '',
      studentId: 'STU001',
      studentName: 'Akande Johnson',
      totalMarks: 100,
      marksObtained: 82,
      percentage: 82,
      grade: 'A',
      answers: [],
      startTime: new Date(),
      endTime: new Date(),
      duration: 60,
      position: 2,
    },
    {
      id: '3',
      examId: selectedExam?.id || '',
      studentId: 'STU003',
      studentName: 'Eze Chukwu',
      totalMarks: 100,
      marksObtained: 75,
      percentage: 75,
      grade: 'B',
      answers: [],
      startTime: new Date(),
      endTime: new Date(),
      duration: 60,
      position: 3,
    },
    {
      id: '4',
      examId: selectedExam?.id || '',
      studentId: 'STU004',
      studentName: 'Grace Adeyemi',
      totalMarks: 100,
      marksObtained: 68,
      percentage: 68,
      grade: 'C',
      answers: [],
      startTime: new Date(),
      endTime: new Date(),
      duration: 60,
      position: 4,
    },
  ];

  const handleSelectExam = (exam: Exam) => {
    setSelectedExam(exam);
    setViewType('exam');
  };

  const handleSubmitExam = (answers: StudentAnswer[]) => {
    // Mock result generation - replace with real calculation
    const marksObtained = Math.floor(Math.random() * (selectedExam?.totalMarks || 100));
    const result: ExamResult = {
      id: `result-${Date.now()}`,
      examId: selectedExam?.id || '',
      studentId: 'STU001',
      studentName: 'Akande Johnson',
      totalMarks: selectedExam?.totalMarks || 100,
      marksObtained,
      percentage: Math.round((marksObtained / (selectedExam?.totalMarks || 100)) * 100),
      grade: 'A',
      answers: answers.map((ans) => ({
        ...ans,
        markedCorrect: Math.random() > 0.3,
        marksObtained: Math.floor(Math.random() * 5),
      })),
      startTime: new Date(),
      endTime: new Date(),
      duration: selectedExam?.duration || 60,
      position: 2,
    };

    setExamResult(result);
    setViewType('results');
  };

  const handleBackToDashboard = () => {
    setViewType('dashboard');
    setSelectedExam(null);
    setExamResult(null);
  };

  return (
    <div>
      {viewType === 'dashboard' && (
        <div className="min-h-screen bg-background p-6">
          <div className="max-w-7xl mx-auto">
            <ExamDashboard onSelectExam={handleSelectExam} />
          </div>
        </div>
      )}

      {viewType === 'exam' && selectedExam && (
        <ExamInterface
          exam={selectedExam}
          onSubmit={handleSubmitExam}
          onCancel={handleBackToDashboard}
        />
      )}

      {viewType === 'results' && selectedExam && examResult && (
        <ResultsPage
          exam={selectedExam}
          result={examResult}
          classRankings={mockClassRankings}
          onDone={handleBackToDashboard}
        />
      )}
    </div>
  );
}
